import Vue from 'vue';
import Vuex from 'vuex';

// Modules import downhere
import jStoreLogin from './jStoreLogin';
import jStoreNotificationScreen from './jStoreNotificationScreen';
import jStoreKurikulum from './jStoreKurikulum';
import jStoreKesiswaan from './jStoreKesiswaan';
import jStoreHubin from './jStoreHubin';
import jStoreSetting from './jStoreSetting';

// Initialize vuex
Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

export default new Vuex.Store({
  modules: {
    // Include imported modules in here
    jStoreLogin,
    jStoreNotificationScreen,
    jStoreKurikulum,
    jStoreKesiswaan,
    jStoreHubin,
    jStoreSetting,
  },
  strict: debug,
});



// WEBPACK FOOTER //
// ./src/stores/index.js